import FieldTypesEnum from '../Enums/FieldTypesEnum';
import moneyHelper from '../Helpers/moneyHelper';

export default class MyOfficeAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.CuName = '';
      this.AsSassieAsgnId = '';
      this.AsFee = '';
      this.AsFeeAddit = '';
      this.AsReimbursement = '';
      this.AsTravel = '';
      this.AsGaming = '';
      this.AsMisc = '';
      this.AsLdvname = '';
      this.AsFieldworkFee = '';
      this.AsEvname = '';
      this.LgsDesc = '';
      this.AsEvaluatorCompletedDate = '';
      this.CuCountry = '';
      this.AsRcycode = '';
      this.OpportunityCurrencyCode = '';
    } else {
      this.CuName = item.cuName;
      this.AsSassieAsgnId = item.asSassieAsgnId;
      this.AsFee = item.asFee;
      this.AsFeeAddit = item.asFeeAddit;
      this.AsReimbursement = item.asReimbursement;
      this.AsTravel = item.asTravel;
      this.AsGaming = item.asGaming;
      this.AsMisc = item.asMisc;
      this.AsLdvname = item.asLdvname;
      this.AsFieldworkFee = item.asFieldworkFee;
      this.AsEvname = item.asEvname;
      this.LgsDesc = item.lgsDesc;
      this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
      this.CuCountry = item.cuCountry;
      this.AsRcycode = item.asRcycode;
      this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
    }
  }

  //   static NameOfTheIdField() {
  //     return "CiId";
  //   }

  //   static nameOfTheItemDetailList() {
  //     return "Invoices";
  //   }

  static MoneyFields = ['AsFee', 'AsFeeAddit', 'AsReimbursement', 'AsTravel', 'AsGaming', 'AsMisc'];

  static Currency() {
    return 'AsRcycode';
  }

  //   static MoneyFieldsSecondary = [];

  //   static CurrencySecondary() {
  //     return "";
  //   }

  static DateFields = ['AsEvaluatorCompletedDate'];
  //   static BoolFields = [];

  //   static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Location',
        orderById: 'CuName',
        data: 'CuName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Apollo ID',
        orderById: 'AsSassieAsgnId',
        data: 'AsSassieAsgnId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Client Fee',
        orderById: 'AsFee',
        data: 'AsFee',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Addit. Fee',
        orderById: 'AsFeeAddit',
        data: 'AsFeeAddit',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Reimb.',
        orderById: 'AsReimbursement',
        data: 'AsReimbursement',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Travel',
        orderById: 'AsTravel',
        data: 'AsTravel',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Gaming',
        orderById: 'AsGaming',
        data: 'AsGaming',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'FW Office',
        orderById: 'AsLdvname',
        data: 'AsLdvname',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'FW Fee',
        orderById: 'AsFieldworkFee',
        data: (item) => moneyHelper.toMoneyFormat(item.AsFieldworkFee, item.OpportunityCurrencyCode),
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Evaluator',
        orderById: 'AsEvname',
        data: 'AsEvname',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Status',
        orderById: 'LgsDesc',
        data: 'LgsDesc',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDate',
        data: 'AsEvaluatorCompletedDate',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Country',
        orderById: 'CuCountry',
        data: 'CuCountry',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }
}
